import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

interface QuestionDropdownInputProps {
  value: string | undefined
  onChange: (value: string) => void
  disabled?: boolean
  options: string[]
  defaultValue?: string
}

export function QuestionDropdownInput({
  value,
  onChange,
  disabled,
  options,
  defaultValue,
}: QuestionDropdownInputProps) {
  const answerValue = value ?? defaultValue ?? ""

  return (
    <Select
      value={answerValue || undefined}
      onValueChange={(v) => {
        if (v == null) return
        onChange(v)
      }}
      disabled={disabled}
    >
      <SelectTrigger size="sm">
        <SelectValue placeholder="Select an option…">
          {answerValue || undefined}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option} value={option}>
            {option}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
